// import React, { useEffect, useState } from "react";
// import { Button, Col, Container, Form, Row } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import { getAllLanguage } from "../../../../store/language/actions";
// import { toast } from "react-toastify";
// import FadeLoader from "react-spinners/FadeLoader";
// import { useNavigate } from "react-router-dom";
// import { AddCharacter, uploadFile } from "../../../../store/actions";
// const AddCharacterType = () => {
//   const { loading } = useSelector((state) => state.Subscription);
//   const dispatch = useDispatch();
//   const [language, setLanguage] = useState([]);
//   const [isLoading, setIsLoading] = useState();
//   const [isAudioLoading, setIsAudioLoading] = useState();
//   const [isDisabled, setIsDisabled] = useState(false);
//   const navigate = useNavigate();
//   const [errors, setErrors] = useState({});
//   const [formData, setFormData] = useState({
//     type: "",
//     name: "",
//     image: "",
//     gender: "",
//     styleType: "",
//     audio: "",
//     titles: [
//       {
//         language: "",
//         title: "",
//       },
//     ],
//   });
//   const fetchLanguages = async () => {
//     try {
//       const callback = (err, res) => {
//         if (err) {
//           toast.error(err);
//           console.error(err);
//         } else {
//           setLanguage(res);
//         }
//       };
//       dispatch(getAllLanguage({ callback }));
//     } catch (error) {
//       console.error("Error fetching languages:", error);
//     }
//   };
//   useEffect(() => {
//     fetchLanguages();
//   }, []);
//   const validateFormData = () => {
//     const newErrors = {};
//     if (!formData.type) newErrors.type = "Type is required";
//     if (!formData.name) newErrors.name = "Name is required";
//     if (!formData.gender) newErrors.gender = "Gender is required";
//     if (!formData.styleType) newErrors.styleType = "StyleType is required";
//     if (!formData.audio && formData.accent)
//       newErrors.audio = "Audio is required";
//     // if (!formData.image) newErrors.image = "Image is required";
//     formData.titles.forEach((title, index) => {
//       if (!title.language)
//         newErrors[`titles-${index}-language`] = "Language is required";
//       if (!title.title)
//         newErrors[`titles-${index}-title`] = "Title is required";
//     });
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//     setErrors({ ...errors, [name]: "" });
//   };
//   const handleTitleTypeChange = (index, field, value) => {
//     const updatedTitles = [...formData.titles];
//     updatedTitles[index] = {
//       ...updatedTitles[index],
//       [field]: value,
//     };
//     setFormData({ ...formData, titles: updatedTitles });
//     setErrors((prev) => ({
//       ...prev,
//       [`titles-${index}-${field}`]: "",
//     }));
//   };
//   const addTitleType = () => {
//     setFormData({
//       ...formData,
//       titles: [...formData.titles, { language: "", title: "" }],
//     });
//   };
//   const removeTitleType = (index) => {
//     const updatedTitles = formData.titles.filter((_, i) => i !== index);
//     setFormData({ ...formData, titles: updatedTitles });
//   };
//   const handleFiles = (_files) => {
//     const MAX_FILE_SIZE = 50 * 1024 * 1024;
//     const files = Array.from(_files).filter(
//       (file) => file.size <= MAX_FILE_SIZE
//     );
//     if (files.length < _files.length) {
//       toast.error("Max file upload size is 50MB");
//       return;
//     }
//     setFormData((prev) => ({
//       ...prev,
//       image: URL.createObjectURL(files[0]),
//     }));
//     setIsLoading(true);
//     const callback = (err, res) => {
//       if (err) {
//         console.error("File upload error:", err);
//         toast.error("Failed to upload file");
//       } else {
//         console.log("Response with URL:", res);
//         toast.success(res.message);
//         setFormData((prev) => ({
//           ...prev,
//           image: res?.data?.url,
//         }));
//       }
//       setIsLoading(false);
//     };
//     dispatch(uploadFile({ data: files[0], callback }));
//   };
//   const handleAudioFiles = (_files) => {
//     const MAX_FILE_SIZE = 50 * 1024 * 1024;
//     const files = Array.from(_files).filter(
//       (file) => file.size <= MAX_FILE_SIZE
//     );
//     if (files.length < _files.length) {
//       toast.error("Max file upload size is 50MB");
//       return;
//     }
//     setFormData((prev) => ({
//       ...prev,
//       audio: URL.createObjectURL(files[0]),
//     }));
//     setIsAudioLoading(true);
//     const callback = (err, res) => {
//       if (err) {
//         console.error("File upload error:", err);
//         toast.error("Failed to upload file");
//       } else {
//         console.log("Response with URL:", res);
//         toast.success(res.message);
//         setFormData((prev) => ({
//           ...prev,
//           audio: res?.data?.url,
//         }));
//       }
//       setIsAudioLoading(false);
//     };
//     dispatch(uploadFile({ data: files[0], callback }));
//   };
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setIsDisabled(true);
//     if (!validateFormData()) {
//       setIsDisabled(false);
//       return;
//     }
//     try {
//       const callback = (err, res) => {
//         if (err) {
//           toast.error(err);
//           console.error("Error submitting:", err);
//         } else {
//           toast.success(res.message);
//           setFormData({
//             modalType: "",
//             image: "",
//             audio: "",
//             titles: [
//               {
//                 language: "",
//                 title: "",
//               },
//             ],
//           });
//           navigate("/character-setting");
//         }
//         setIsDisabled(false);
//       };
//       dispatch(AddCharacter({ data: formData, callback }));
//     } catch (error) {
//       console.error("Error during submission:", error);
//       setIsDisabled(false);
//     }
//   };
//   return (
//     <>
//       {loading && (
//         <div className="main-loader">
//           <FadeLoader size={1000} />
//         </div>
//       )}
//       <section className="addForm position-relative py-3">
//         <Container>
//           <Row>
//             <Col lg="12" className="my-2">
//               <div className="cardCstm p-3 rounded bg-white">
//                 <Form className="mx-auto" onSubmit={handleSubmit}>
//                   <div className="py-3">
//                     <div className="topHead pb-2">
//                       <h5 className="m-0 fw-sbold" style={{ color: "#2E3A59" }}>
//                         Add Modal:
//                       </h5>
//                     </div>
//                     <div className="mx-auto" style={{ maxWidth: 777 }}>
//                       <Row className="justify-content-center">
//                         <Col md="6" className="my-2">
//                           <label
//                             htmlFor="ModalType"
//                             className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase"
//                           >
//                             Modal Type
//                           </label>
//                           <select
//                             className="form-control"
//                             name="type"
//                             value={formData.type}
//                             onChange={handleChange}
//                           >
//                             <option value="">Select Modal type</option>
//                             <option value="Personality">Personality</option>
//                             <option value="Hobby">Hobby</option>
//                             {/* <option value="Background">Background</option>
//                             <option value="Cloths">Cloths</option>
//                             <option value="Occupation">Occupation</option>
//                             <option value="Ethnicity">Ethnicity</option>
//                             <option value="Accent">Accent</option>
//                             <option value="BodyType">Body Type</option>
//                             <option value="Eye">Eye</option>
//                             <option value="HairStyle">Hair Style</option>
//                             <option value="HairColor">Hair Color</option>
//                             <option value="Butt">Butt/Hip</option>
//                             <option value="Breast">Breast/Chest</option>
//                             <option value="Accessories">Accessories</option>
//                             <option value="Outfit">Outfit</option>
//                             <option value="Pose">Pose</option>
//                             <option value="Action">Action</option>
//                             <option value="Scene">Scene</option> */}
//                             {/* <option value="Prompts">Prompts</option> */}
//                           </select>
//                           {errors.type && (
//                             <small className="text-danger">{errors.type}</small>
//                           )}
//                         </Col>
//                         <Col md="6" className="my-2">
//                           <label
//                             htmlFor="name"
//                             className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase"
//                           >
//                             Name
//                           </label>
//                           <input
//                             type="text"
//                             className="form-control"
//                             name="name"
//                             value={formData.name}
//                             onChange={handleChange}
//                           />
//                           {errors.name && (
//                             <small className="text-danger">{errors.name}</small>
//                           )}
//                         </Col>
//                         <Col md="6" className="my-2">
//                           <label
//                             htmlFor="Gender"
//                             className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase"
//                           >
//                             Gender
//                           </label>
//                           <select
//                             className="form-control"
//                             name="gender"
//                             value={formData.gender}
//                             onChange={handleChange}
//                           >
//                             <option value="">Select Gender</option>
//                             <option value="male">Male</option>
//                             <option value="female">Female</option>
//                           </select>
//                           {errors.gender && (
//                             <small className="text-danger">
//                               {errors.gender}
//                             </small>
//                           )}
//                         </Col>
//                         <Col md="6" className="my-2">
//                           <label
//                             htmlFor="Gender"
//                             className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase"
//                           >
//                             Style type
//                           </label>
//                           <select
//                             className="form-control"
//                             name="styleType"
//                             value={formData.styleType}
//                             onChange={handleChange}
//                           >
//                             <option value="">Select Style</option>
//                             <option value="Realistic">Realistic</option>
//                             <option value="Anime">Anime</option>
//                           </select>
//                           {errors.styleType && (
//                             <small className="text-danger">
//                               {errors.styleType}
//                             </small>
//                           )}
//                         </Col>
//                         <Row className="mx-0">
//                           <Col md="6" className="my-2">
//                             <label
//                               htmlFor="Image"
//                               className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase"
//                             >
//                               Banner Image
//                             </label>
//                             {isLoading ? (
//                               <ul className="list-unstyled pl-0 mb-0 d-flex align-items-center gap-2 flex-wrap">
//                                 <li className="d-flex align-items-center gap-2 position-relative">
//                                   <div className="d-flex align-items-center bg-light py-2 px-4 rounded-pill position-relative">
//                                     <span
//                                       className="spinner-border text-primary"
//                                       role="status"
//                                       aria-hidden="true"
//                                     ></span>
//                                     <span className="ms-2 text-primary">
//                                       Uploading...
//                                     </span>
//                                   </div>
//                                 </li>
//                               </ul>
//                             ) : (
//                               <ul className="list-unstyled pl-0 mb-0 d-flex align-items-center gap-2 flex-wrap">
//                                 {formData?.image &&
//                                 typeof formData.image === "string" ? (
//                                   <li className="d-flex align-items-center gap-2 position-relative">
//                                     <div className="d-flex align-items-center bg-light py-2 px-4 rounded-pill position-relative">
//                                       <img
//                                         className="rounded-4"
//                                         src={formData.image}
//                                         alt="Selected Icon"
//                                         width={100}
//                                         height={100}
//                                       />
//                                       <Button
//                                         variant="danger"
//                                         className="btn-sm border-0 p-0 fw-sbold d-flex align-items-center justify-content-center position-absolute rounded-circle"
//                                         style={{
//                                           top: 5,
//                                           right: 5,
//                                           fontSize: 8,
//                                           height: 12,
//                                           width: 12,
//                                         }}
//                                         onClick={() =>
//                                           setFormData({
//                                             ...formData,
//                                             image: "",
//                                           })
//                                         }
//                                       >
//                                         X
//                                       </Button>
//                                     </div>
//                                   </li>
//                                 ) : (
//                                   <input
//                                     type="file"
//                                     className="form-control"
//                                     name="image"
//                                     accept=".jpeg,.jpg,.png,.gif,.bmp,.webp"
//                                     onChange={(e) =>
//                                       handleFiles(e.target.files)
//                                     }
//                                   />
//                                 )}
//                               </ul>
//                             )}
//                             {errors.image && (
//                               <small className="text-danger">
//                                 {errors.image}
//                               </small>
//                             )}
//                           </Col>
//                           {formData.type === "Accent" && (
//                             <Col md="6" className="my-2">
//                               <label
//                                 htmlFor="Image"
//                                 className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase"
//                               >
//                                 Upload Accent Audio
//                               </label>
//                               {isAudioLoading ? (
//                                 <ul className="list-unstyled pl-0 mb-0 d-flex align-items-center gap-2 flex-wrap">
//                                   <li className="d-flex align-items-center gap-2 position-relative">
//                                     <div className="d-flex align-items-center bg-light py-2 px-4 rounded-pill position-relative">
//                                       <span
//                                         className="spinner-border text-primary"
//                                         role="status"
//                                         aria-hidden="true"
//                                       ></span>
//                                       <span className="ms-2 text-primary">
//                                         Uploading...
//                                       </span>
//                                     </div>
//                                   </li>
//                                 </ul>
//                               ) : (
//                                 <ul className="list-unstyled pl-0 mb-0 d-flex align-items-center gap-2 flex-wrap">
//                                   {formData?.audio &&
//                                   typeof formData.audio === "string" ? (
//                                     <li className="d-flex align-items-center gap-2 position-relative">
//                                       <div className="d-flex align-items-center bg-light py-2 px-4 rounded-pill position-relative">
//                                         <audio controls className="rounded-4">
//                                           <source
//                                             src={formData.audio}
//                                             type="audio/mp3"
//                                           />
//                                           Your browser does not support the
//                                           audio element.
//                                         </audio>
//                                         <Button
//                                           variant="danger"
//                                           className="btn-sm border-0 p-0 fw-sbold d-flex align-items-center justify-content-center position-absolute rounded-circle"
//                                           style={{
//                                             top: 5,
//                                             right: 5,
//                                             fontSize: 8,
//                                             height: 12,
//                                             width: 12,
//                                           }}
//                                           onClick={() =>
//                                             setFormData({
//                                               ...formData,
//                                               audio: "",
//                                             })
//                                           }
//                                         >
//                                           X
//                                         </Button>
//                                       </div>
//                                     </li>
//                                   ) : (
//                                     <input
//                                       type="file"
//                                       className="form-control"
//                                       name="audio"
//                                       accept=".mp3"
//                                       onChange={(e) =>
//                                         handleAudioFiles(e.target.files)
//                                       }
//                                     />
//                                   )}
//                                 </ul>
//                               )}
//                               {errors.audio && (
//                                 <small className="text-danger">
//                                   {errors.audio}
//                                 </small>
//                               )}
//                             </Col>
//                           )}
//                         </Row>
//                         {formData.titles.map((item, index) => (
//                           <React.Fragment key={index}>
//                             <Col md="6" className="my-2">
//                               <label
//                                 htmlFor={`language-${index}`}
//                                 className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase"
//                               >
//                                 Select Language
//                               </label>
//                               <select
//                                 className="form-control"
//                                 value={item.language}
//                                 onChange={(e) =>
//                                   handleTitleTypeChange(
//                                     index,
//                                     "language",
//                                     e.target.value
//                                   )
//                                 }
//                               >
//                                 <option value="">Select Language</option>
//                                 {language.map((lang) => (
//                                   <option key={lang._id} value={lang.code}>
//                                     {lang.name}
//                                   </option>
//                                 ))}
//                               </select>
//                               {errors[`titles-${index}-language`] && (
//                                 <small className="text-danger">
//                                   {errors[`titles-${index}-language`]}
//                                 </small>
//                               )}
//                             </Col>
//                             <Col md="6" className="my-2">
//                               <label
//                                 htmlFor={`title-${index}`}
//                                 className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase"
//                               >
//                                 Title
//                               </label>
//                               <div className="d-flex align-items-center">
//                                 <input
//                                   type="text"
//                                   className="form-control me-2"
//                                   value={item.title}
//                                   onChange={(e) =>
//                                     handleTitleTypeChange(
//                                       index,
//                                       "title",
//                                       e.target.value
//                                     )
//                                   }
//                                 />
//                                 <Button
//                                   variant="danger"
//                                   className="btn-sm"
//                                   onClick={() => removeTitleType(index)}
//                                   disabled={formData.titles.length === 1}
//                                 >
//                                   Remove
//                                 </Button>
//                               </div>
//                               {errors[`titles-${index}-title`] && (
//                                 <small className="text-danger">
//                                   {errors[`titles-${index}-title`]}
//                                 </small>
//                               )}
//                             </Col>
//                           </React.Fragment>
//                         ))}

//                         <div className="d-flex px-4">
//                           <Button
//                             className="mt-2 btn-sm"
//                             onClick={addTitleType}
//                             type="button"
//                           >
//                             Add More
//                           </Button>
//                         </div>
//                       </Row>
//                     </div>
//                   </div>
//                   <div className="py-3">
//                     <div className="mx-auto" style={{ maxWidth: 777 }}>
//                       <Row>
//                         <Col md="5" className="my-2">
//                           <Button
//                             className="text-uppercase fw-sbold w-100 btn-danger"
//                             onClick={() => navigate("/character-setting")}
//                           >
//                             Cancel
//                           </Button>
//                         </Col>
//                         <Col md="7" className="my-2">
//                           <Button
//                             disabled={isDisabled}
//                             type="submit"
//                             className="text-uppercase fw-sbold w-100 btn-primary"
//                           >
//                             {isDisabled ? "Submitting..." : "Submit"}
//                           </Button>
//                         </Col>
//                       </Row>
//                     </div>
//                   </div>
//                 </Form>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// };
// export default AddCharacterType;

import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import FadeLoader from "react-spinners/FadeLoader";
import { useNavigate } from "react-router-dom";
import { AddCharacter } from "../../../../store/actions";

const AddCharacterType = () => {
  const { loading } = useSelector((state) => state.Subscription);
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    type: "",
    name: "",
    titles: [
      {
        language: "en",
        title: "",
      },
    ],
  });

  const validateFormData = () => {
    const newErrors = {};
    if (!formData.type) newErrors.type = "Type is required";
    if (!formData.name) newErrors.name = "Name is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: newValue,
      };

      // If name field is changed, also update the title
      if (name === "name") {
        updated.titles = [
          {
            language: "en",
            title: newValue,
          },
        ];
      }

      return updated;
    });

    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsDisabled(true);

    if (!validateFormData()) {
      setIsDisabled(false);
      return;
    }

    console.log(formData, "formdata =======<>");

    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
          console.error("Error submitting:", err);
        } else {
          toast.success("Character Type Added Successfully");
          setFormData({
            type: "",
            name: "",
            titles: [
              {
                language: "en",
                title: "",
              },
            ],
          });
          navigate("/character-setting");
        }
        setIsDisabled(false);
      };
      dispatch(AddCharacter({ data: formData, callback }));
    } catch (error) {
      console.error("Error during submission:", error);
      setIsDisabled(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <section className="addForm position-relative py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 rounded bg-white">
                <Form className="mx-auto" onSubmit={handleSubmit}>
                  <div className="py-3">
                    <div className="topHead pb-2">
                      <h5 className="m-0 fw-sbold" style={{ color: "#2E3A59" }}>
                        Add Modal:
                      </h5>
                    </div>
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row className="justify-content-center">
                        <Col md="6" className="my-2">
                          <label
                            htmlFor="ModalType"
                            className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase"
                          >
                            Modal Type
                          </label>
                          <select
                            className="form-control"
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                          >
                            <option value="">Select Modal type</option>
                            <option value="Personality">Personality</option>
                            <option value="Hobby">Hobby</option>
                            <option value="Background">Background</option>
                          </select>
                          {errors.type && (
                            <small className="text-danger">{errors.type}</small>
                          )}
                        </Col>

                        <Col md="6" className="my-2">
                          <label
                            htmlFor="name"
                            className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase"
                          >
                            Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                          />
                          {errors.name && (
                            <small className="text-danger">{errors.name}</small>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <div className="py-3">
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row>
                        <Col md="5" className="my-2">
                          <Button
                            className="text-uppercase fw-sbold w-100 btn-danger"
                            onClick={() => navigate("/character-setting")}
                          >
                            Cancel
                          </Button>
                        </Col>
                        <Col md="7" className="my-2">
                          <Button
                            disabled={isDisabled}
                            type="submit"
                            className="text-uppercase fw-sbold w-100 btn-primary"
                          >
                            {isDisabled ? "Submitting..." : "Submit"}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddCharacterType;
